// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
a {
  color: inherit;
  text-decoration: none;
}

img {
  display: block;
  max-inline-size: 100%;
}

hr {
  border-style: solid;
  border-color: var(--theme-secondary-text-color);
}

.material-symbols-outlined {
  font-variation-settings:
  'FILL' 0,
  'wght' 400,
  'GRAD' 0,
  'opsz' 24;
  text-orientation: upright;
}
`, "",{"version":3,"sources":["webpack://./src/common.css"],"names":[],"mappings":";AACA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,+CAA+C;AACjD;;AAEA;EACE;;;;WAIS;EACT,yBAAyB;AAC3B","sourcesContent":["\na {\n  color: inherit;\n  text-decoration: none;\n}\n\nimg {\n  display: block;\n  max-inline-size: 100%;\n}\n\nhr {\n  border-style: solid;\n  border-color: var(--theme-secondary-text-color);\n}\n\n.material-symbols-outlined {\n  font-variation-settings:\n  'FILL' 0,\n  'wght' 400,\n  'GRAD' 0,\n  'opsz' 24;\n  text-orientation: upright;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___.toString();
